import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
    IconButton,
    Switch,
    Grid,
    Button,
    MenuItem,
    InputAdornment
} from '@material-ui/core';
import * as logger from '../../../../logger';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Switches,
    Autocomplete
} from 'mui-rff';
import { Form, Field } from 'react-final-form';
import { BiltyInsuranceSignatureCss as useStyles } from '../BiltyCss';
import AddIcon from '@material-ui/icons/Add';
import AddInsuranceDialog from '../../../components/JourneyBiltyDialogs/AddInsuranceDialog';
import BiltyEditTermsDialog from '../../../components/JourneyBiltyDialogs/BiltyEditTermsDialog';
import { getElrInfo, biltyDataPopulated } from '../../../../store/actions/tripActionCreator';
import { ProviderIcon } from '../../../../components/icons';
import EditIcon from '@material-ui/icons/Edit';
import { numberFormat, getDateInStringDocumentDDMMMYYYY } from '../../../../utils/utils';
import S3Uploader from '../../../components/s3Uploader/s3Uploader';
import { SizeMe } from 'react-sizeme';
import { Document, Page, pdfjs } from 'react-pdf';
import AmountInput from '../../../components/Inputs/AmountInput';
import TextInputState from '../../../components/Inputs/TextInputState';
import Alert from '@material-ui/lab/Alert';
import { replaceCommas } from '../../../../utils/utils';

export const BiltyInsuranceSignature = ({ user,selectedTrip,selectedLr,journey,updateJourney, trip, dispatchGetElrInfo, onDataPopulated, open, dispatchBiltyDataPopulated }) => {

    let submit;

    const classes = useStyles();

    const elrId = selectedLr && selectedLr.id ? selectedLr.id : ""

    const [insuranceDialog, setInsuranceDialog] = useState(false);
    const [insuranceDetailsData, setInsuranceDetailsData] = useState({});
    const [wayBill, setWayBill] = useState("");
    const [goodsInvoiceValue, setGoodsInvoiceValue] = useState("");
    const [invoiceValueState, setInvoiceValueState] = useState("");
    const [editFlag, setEditFlag] = useState(false);
    const [editTerms, setEditTerms] = useState(false);
    const [termsValue, setTermsValue] = useState("");
    const [signaturePhoto, setSignaturePhoto] = useState("");
    const [signatureCheck, setSignatureCheck] = useState(false);
    const [checkFileType, setCheckFileType] = useState(false);
    const [sizeFlag, setSizeFlag] = useState(false);

    const initialValues = {
        eWaybill: wayBill,
        goodsInvoice: goodsInvoiceValue,
        invoiceValue: invoiceValueState
    }

    useEffect(() => {

        dispatchBiltyDataPopulated(true);

    }, [open]);

    useEffect(() => {

        if (trip && trip.elrInfo && trip.elrInfo.waybill_details) {
            setWayBill(trip.elrInfo.waybill_details.waybill_number);
            setGoodsInvoiceValue(trip.elrInfo.waybill_details.invoice_number);
            setInvoiceValueState(trip.elrInfo.waybill_details.invoice_value);
        }

        if (trip && trip.elrInfo) {
            setInsuranceDetailsData(trip.elrInfo);
            setSignaturePhoto(trip.elrInfo.signature_link);
            setSignatureCheck(trip.elrInfo.include_signature ? trip.elrInfo.include_signature : false);
        }


    }, [trip.elrInfo]);

    useEffect(() => {

        if (trip && trip.elrInfo && trip.elrInfo.terms_and_conditions) {
            setTermsValue(trip.elrInfo.terms_and_conditions);
        } else
            if (trip && trip.elrLoadData && trip.elrLoadData.terms_and_conditions) {
                setTermsValue(trip.elrLoadData.terms_and_conditions)
            }

    }, []);

    useEffect(() => {

        if (insuranceDetailsData && insuranceDetailsData.insurance_details && insuranceDetailsData.insurance_details.provider || wayBill || goodsInvoiceValue || invoiceValueState || signaturePhoto || termsValue || signatureCheck || !signatureCheck) {

            const values = {
                terms_and_conditions: termsValue,
                include_signature: signatureCheck,
                waybill_details: {
                    waybill_number: wayBill,
                    invoice_value: replaceCommas(invoiceValueState),
                    invoice_number: goodsInvoiceValue
                },
                insurance_details: {
                    // insured_on: insuranceDetailsData && insuranceDetailsData.insurance_details && insuranceDetailsData.insurance_details.insured_on ? insuranceDetailsData.insurance_details.insured_on : "",
                    // insured_value: insuranceDetailsData && insuranceDetailsData.insurance_details && insuranceDetailsData.insurance_details.insured_value ? insuranceDetailsData.insurance_details.insured_value : "",
                    // policy_number: insuranceDetailsData && insuranceDetailsData.insurance_details && insuranceDetailsData.insurance_details.policy_number ? insuranceDetailsData.insurance_details.policy_number : "",
                    // provider: insuranceDetailsData && insuranceDetailsData.insurance_details && insuranceDetailsData.insurance_details.provider ? insuranceDetailsData.insurance_details.provider : "",
                    // risk_type: insuranceDetailsData && insuranceDetailsData.insurance_details && insuranceDetailsData.insurance_details.risk_type ? insuranceDetailsData.insurance_details.risk_type : ""
                }

            }

            if (signatureCheck) {
                values.signature_link = signaturePhoto
            }

            if (insuranceDetailsData && insuranceDetailsData.insurance_details && insuranceDetailsData.insurance_details.insured_on) {
                values.insurance_details.insured_on = insuranceDetailsData.insurance_details.insured_on;
            }

            if (insuranceDetailsData && insuranceDetailsData.insurance_details && insuranceDetailsData.insurance_details.insured_value) {
                values.insurance_details.insured_value = insuranceDetailsData.insurance_details.insured_value;
            }

            if (insuranceDetailsData && insuranceDetailsData.insurance_details && insuranceDetailsData.insurance_details.policy_number) {
                values.insurance_details.policy_number = insuranceDetailsData.insurance_details.policy_number;
            }

            if (insuranceDetailsData && insuranceDetailsData.insurance_details && insuranceDetailsData.insurance_details.provider) {
                values.insurance_details.provider = insuranceDetailsData.insurance_details.provider
            }

            if (insuranceDetailsData && insuranceDetailsData.insurance_details && insuranceDetailsData.insurance_details.risk_type) {
                values.insurance_details.risk_type = insuranceDetailsData.insurance_details.risk_type
            }

            onDataPopulated(values);

        }

    }, [insuranceDetailsData.insurance_details, wayBill, goodsInvoiceValue, invoiceValueState, signaturePhoto, termsValue, signatureCheck]);

    const recall = () => {
        dispatchGetElrInfo(elrId,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log('Bilty Insurance Signature Dweb', 'Get ELR info successfull');
                }
            },
            () => {
                logger.log('Bilty Insurance Signature Dweb', 'Get ELR info failed');
            }
        )
    }

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV1}>
                            <div className={classes.divTitleV1}>E-Waybill No.</div>
                            <div>
                                <TextInputState
                                    placeholder="E-Waybill No"
                                    name="eWaybill"
                                    variant="outlined"
                                    size="small"
                                    className={classes.textFieldV1}
                                    onChange={(e) => setWayBill(e.target.value)}
                                />
                            </div>
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV2}>
                            <div className={classes.divTitleV1}>Goods Invoice No.</div>
                            <div>
                                <TextInputState
                                    placeholder="Goods Invoice No"
                                    name="goodsInvoice"
                                    variant="outlined"
                                    size="small"
                                    className={classes.textFieldV1}
                                    onChange={(e) => setGoodsInvoiceValue(e.target.value)}
                                />
                            </div>
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV2}>
                            <div className={classes.divTitleV1}>Invoice Value</div>
                            <div>
                                <AmountInput
                                    placeholder="Invoice Value"
                                    name="invoiceValue"
                                    variant="outlined"
                                    size="small"
                                    className={classes.textFieldV1}
                                    onChange={(e) => setInvoiceValueState(e.target.value)}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">&#x20b9;</InputAdornment>
                                    }}
                                />
                            </div>
                        </div>
                    </>
                )
            }
        ]
    }

    const onSubmit = values => {

    }

    const handleAddInsurance = () => {
        setInsuranceDialog(true);
        setEditFlag(false);
    }

    const handleInsuranceDialogClose = () => {
        setInsuranceDialog(false);
    }

    const handleInsuranceDialogConfirm = (value) => {
        setInsuranceDialog(false);
        setInsuranceDetailsData(value);
    }

    const handleEditClick = () => {
        setInsuranceDialog(true);
        setEditFlag(true);
    }

    const handleTermsEdit = () => {
        setEditTerms(true);
    }

    const handleEditTermsClose = () => {
        setEditTerms(false);
    }

    const handleEditTermsConfirm = (value) => {
        setEditTerms(false);
        setTermsValue(value);
    }

    const handleAddSignature = (file) => {
        setCheckFileType(false);
        setSizeFlag(false);
        setSignaturePhoto(file);
        setSignatureCheck(true);
    }

    const handleChange = (e) => {
        setSignatureCheck(!signatureCheck);
    }

    const handleInvalidUpload = (values) => {
        if (values.checkFileType) {
            setCheckFileType(true);
        }
        if (values.sizeFlag) {
            setSizeFlag(true);
        }
    }

    return (
        <>
            <div>

                <div className={classes.divContainerV1}>
                    <div className={classes.divV1}>Insurance Details</div>
                    {insuranceDetailsData && insuranceDetailsData.insurance_details && !insuranceDetailsData.insurance_details.provider &&
                        <div className={classes.divContainer}>
                            <div>
                                <Button variant="outlined" className={classes.buttonV1} startIcon={<AddIcon className={classes.addIcon} />} onClick={() => handleAddInsurance()} >
                                    Add Insurance
                                </Button>
                            </div>
                        </div>
                    }
                    {insuranceDetailsData && insuranceDetailsData.insurance_details && insuranceDetailsData.insurance_details.provider &&
                        <>
                            <div className={classes.divInsuranceCard}>

                                <div className={classes.divAlignV2} >

                                    <div className={classes.divV3}>
                                        <div>
                                            <ProviderIcon className={classes.emptyIcon} />
                                        </div>
                                        <div className={classes.divV2}>
                                            <div className={classes.divProvider}>Insurance Provider</div>
                                            <div className={classes.providerText}>{insuranceDetailsData && insuranceDetailsData.insurance_details && insuranceDetailsData.insurance_details.provider ? insuranceDetailsData.insurance_details.provider : "--"}</div>
                                        </div>

                                    </div>

                                    <div>
                                        <IconButton variant='outlined' className={classes.editButtonV1} onClick={handleEditClick} >
                                            <EditIcon className={classes.editIcon} />
                                        </IconButton>
                                    </div>

                                </div>

                                <hr className={classes.dividerV1} />

                                <div>

                                    <div className={classes.divAlignV3}>
                                        <div className={classes.divTitleV2}>
                                            Insurance Policy No :
                                        </div>
                                        <div className={classes.divValue}>{insuranceDetailsData && insuranceDetailsData.insurance_details && insuranceDetailsData.insurance_details.policy_number ? insuranceDetailsData.insurance_details.policy_number : "--"}</div>
                                    </div>

                                    <div className={classes.divAlignV1}>
                                        <div className={classes.divTitleV2}>
                                            Insured On :
                                        </div>
                                        <div className={classes.divValue}>
                                            {insuranceDetailsData && insuranceDetailsData.insurance_details && insuranceDetailsData.insurance_details.insured_on ? getDateInStringDocumentDDMMMYYYY(insuranceDetailsData.insurance_details.insured_on) : ""}
                                        </div>
                                    </div>

                                    <div className={classes.divAlignV1}>
                                        <div className={classes.divTitleV2}>Risk Type : </div>
                                        <div className={classes.divValue}>
                                            {insuranceDetailsData && insuranceDetailsData.insurance_details && insuranceDetailsData.insurance_details.risk_type ? insuranceDetailsData.insurance_details.risk_type : ""}
                                        </div>
                                    </div>

                                    <div className={classes.divAlignV1}>
                                        <div className={classes.divTitleV2}>Insured Value : </div>
                                        <div className={classes.divValue}>
                                            {insuranceDetailsData && insuranceDetailsData.insurance_details && insuranceDetailsData.insurance_details.insured_value ? numberFormat(insuranceDetailsData.insurance_details.insured_value) : ""}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </>
                    }
                </div>

                <div className={classes.divContent}>
                    <div className={classes.divTitle}>Waybill Details</div>
                    <div className={classes.divDes}>Description on waybill here</div>
                    <Form
                        onSubmit={onSubmit}
                        initialValues={initialValues}
                        id="myForm"
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit
                            return (
                                <form onSubmit={handleSubmit} noValidate id="myForm">
                                    <Grid container alignItems="flex-start">
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                    {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
                                </form>
                            )
                        }}
                    />
                </div>

                <div className={classes.divContainerV1}>

                    <div>
                        <div className={classes.divAlign}>
                            <div className={classes.divV1}>Terms & Conditions</div>
                            <div>
                                <Button className={classes.editButton} onClick={() => handleTermsEdit()}>
                                    Edit
                                </Button>
                            </div>
                        </div>
                        <div className={classes.divDisplay}>
                            {termsValue}
                        </div>
                    </div>

                    <div className={classes.mtV1}>
                        <div>
                            <div className={classes.divV1}>Signature</div>
                        </div>
                        {!signaturePhoto &&
                            <div className={classes.divDisplayV1}>
                                <S3Uploader toggle={true} handleFile={handleAddSignature} directoryName={"dweb-images/Bilty/BiltyInsuranceSignature"} fromBiltySignature={true} id="addBiltySignature" displayErrorBelow={handleInvalidUpload} displayErrorMessageBelow={true} />
                            </div>
                        }

                        {signaturePhoto &&
                            <div className={classes.divDisplayV2}>
                                <div className={classes.divV4} >
                                    <img src={signaturePhoto} className={classes.imgV1} />

                                    <div className={classes.divChangeButton}>
                                        <S3Uploader toggle={true} directoryName={"dweb-images/Bilty/BiltyInsuranceSignature"} handleFile={handleAddSignature} fromBiltySignature={true} id="addBiltySignatureChange" displayErrorBelow={handleInvalidUpload} displayErrorMessageBelow={true} />
                                    </div>
                                </div>
                                <div className={classes.divV5}>
                                    <div>
                                        Include Signature here
                                    </div>
                                    <div>
                                        <Switch
                                            checked={signatureCheck}
                                            onChange={handleChange}
                                            name="signatureCheck"
                                            className={classes.switch}
                                            classes={{ track: classes.switchTrack, thumb: classes.switchThumb, checked: classes.switchChecked }}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    <div>
                        {checkFileType &&
                            <Alert severity="error" className="mtV1">Please select only .jpg, .jpeg and .png files</Alert>
                        }
                        {sizeFlag &&
                            <Alert severity="error" className="mtV1">File size must be below 5MB.</Alert>
                        }
                    </div>

                </div>

            </div>

            {insuranceDialog && <AddInsuranceDialog journey={journey} updateJourney={updateJourney} selectedTrip={selectedTrip} selectedLr={selectedLr} open={insuranceDialog} onClose={handleInsuranceDialogClose} onConfirm={handleInsuranceDialogConfirm} edit={editFlag} insuranceData={insuranceDetailsData.insurance_details} />}
            {editTerms && <BiltyEditTermsDialog journey={journey} updateJourney={updateJourney} selectedTrip={selectedTrip} selectedLr={selectedLr} open={editTerms} onClose={handleEditTermsClose} onConfirm={handleEditTermsConfirm} termsData={termsValue} />}
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchGetElrInfo: (elrId, onSuccess, onError) => {
        dispatch(getElrInfo(elrId, onSuccess, onError))
    },
    dispatchBiltyDataPopulated: (value) => {
        dispatch(biltyDataPopulated(value))
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(BiltyInsuranceSignature);